const physicianTypes = ['D.O.', 'M.D.'] as const;

export default physicianTypes;
